import React, { useState, useEffect } from 'react'
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import FormInput from '../components/input';
import CardTypeInput from '../components/radio-button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import { mapStateToProps } from "../../../redux/reducers";
import * as actionType from "../../../redux/actionTypes/csaSignup";
import { connect } from "react-redux";
import TableComponent from "../../common/components/table"
import CancelDetails from './cancelDetails';
import { CustomButton } from '../../common/components/customButton';
import '../../../styles/home.scss';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    InputLabel,
} from '@mui/material';
import Form from 'react-bootstrap/Form';
import { Row, Col } from "react-bootstrap";


import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { convertUTCDateToLocalDate, popUpAlert } from '../../../utils/globalMethods';
import moment from "moment";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { refreshKey } from "../../../redux/actionTypes/administration";
import CancelIcon from '@mui/icons-material/Cancel';

let language = localStorage.getItem("selectedLanguage");
if (language === null) {
  language = "en-US";
}
let languageCode = language.substring(0, 2);
const theme = createTheme({
    typography: {
        h6: {
            fontFamily: "Texta-bold",
        },
        subtitle2: {
            fontFamily: "Texta-bold",
            fontSize: "1.25rem"
        },
        subtitle1: {
            fontFamily: ["Texta-book", "Helvetica", "Arial", "sans-serif"].join(','),
            fontSize: 20,
        },
    },
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function createData(agrmtId, id, setId, vendorId, clientId, shareId, verbiageDocId, vendorName, apprvlStatus, shareNam, agrmntAppId,lastUpdtTs, shareCost, dsc,shareQty,address1, address2, city, state, zipcode,
    day, openTime, closeTime, cancelNotes, cancelESign, clientNam,endDate,paymentType, row) {
    return {
        agrmtId,
        id,
        setId,
        vendorId,
        clientId,
        shareId,
        verbiageDocId,
        vendorName,
        apprvlStatus,
        shareNam,
        agrmntAppId,
        lastUpdtTs:convertUTCDateToLocalDate(moment(new Date()).format('MM/DD/YYYY hh:mm:ss a')),
        shareCost,
        dsc: dsc,
        shareQty:shareQty,
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        zipcode: zipcode,
        day: day,
        openTime: openTime,
        closeTime: closeTime,
        cancelNotes,
        cancelESign,
        clientNam,
        checkboxDisable: (apprvlStatus === "REJCTD" || apprvlStatus === "CANCLD") ? true : false,
        endDate:endDate,
        paymentType,
        row,
    };
}
function CancelFormComponent(props) {
    let loginId = props?.userAuth?.user?.id;
    // eslint-disable-next-line no-unused-vars
    const [month, setMonth] = React.useState('');
    const [rows, setRows] = useState([]);
    const [size, setSize] = useState(10);
    const [from, setFrom] = useState(0);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [columns, setColumns] = useState([])
    const [agreementList, setAgreementList] = useState([])
    const [showLoader, setShowLoader] = useState();
    const [expand] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [tableSort, setTableSort] = useState({ "lastUpdtTs": "DESC" });
    const [showTable, setShowTable] = useState(false);
    const [selectedReason, setSelectedReason] = useState('');
    const [otherReason, setOtherReason] = useState('');
    const [submittedData, setSubmittedData] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [selectMessage, setSelectMessage] = useState('');
    const [selectOption, setSelectOption] = useState('');
    const [cancelAgreementlist,setCancelAgreementList]=useState('');
    const userData = props?.userAuth?.user ? props?.userAuth?.user : JSON.parse(sessionStorage.getItem("userData"));
    const [isLoggin] = useState(loginId ? true : false);
    const [error, setError] = useState('');
    const [apid, setApid] = useState('');
    const [cancelRow,setCancelRow] = useState();
    const [language, setLanguage] = useState({});
    const [yearError, setYearError] = useState('');
    

    useEffect(() => {
        setLanguage(props.signupLanguage)
    }, [props.signupLanguage]);

    const monthOptions = [
        // { value: '', label: 'Month' },
        { value: 'JAN', label: language.January },
        { value: 'FEB', label: language.February },
        { value: 'MAR', label: language.March },
        { value: 'APR', label: language.April },
        { value: 'MAY', label: language.May },
        { value: 'JUN', label: language.June },
        { value: 'JUL', label: language.July },
        { value: 'AUG', label: language.August },
        { value: 'SEP', label: language.September },
        { value: 'OCT', label: language.October },
        { value: 'NOV', label: language.November },
        { value: 'DEC', label: language.December },
    ];

    const cancelOptions = [
        { value: " "},
        { value: "1", text: language["Change in Benefit Amount"] },
        { value: "2", text: language["Change share type"] },
        { value: "3", text: language["Cancelled due to HIP Suspension"]},
        { value: "4", text: language["No reason given"]},
        { value: "5", text: language["Transportation/Medical Issues"]},
        { value: "6", text: language["Unsatisfied with share"]},
        { value: "7", text: language["Other Reason"]}
    ];

    const handleReasonChange = (event) => {
        const reason = event.target.value;
        setSelectedReason(reason);
        if (reason !== '7') {
            setOtherReason('');
        }
    };

    const selectedCancelOption = cancelOptions.find(option => option.value === selectedReason);
    const cancelNotesText = selectedCancelOption ? selectedCancelOption.text : "";

    const handleMonthChange = (event) => {
        setMonth(event.target.value);
        setSelectedMonth(event.target.value);
    };

    const { register, handleSubmit, watch, getValues,setValue, formState: { errors }, reset } = useForm({
        defaultValues: {
            "firstName": "",
            "lastName": "",
            "date": "",
            "month": "",
            "year": "",
            "clientId": "",
            "panNumber":"",
            "cancelNotes": "",
            "cancelESign": "",
            "apid":"",
            "ebt":""
        }
    })

    useEffect(()=>{
        if (props?.csaSignup?.getCancelAgreementList?.getCancelAgreementList?.code === "508") {
            popUpAlert({
                title: "Error",
                text: props?.csaSignup?.getCancelAgreementList?.getCancelAgreementList?.message,
                icon: "error",
                timer:2000,
                showCancelButton: false,
                showConfirmButton: false,
            });
        }

    },[props?.csaSignup?.getCancelAgreementList])


    const handleNext = (page, rowSize) => {
        (size != rowSize) && setSize(rowSize);
        setFrom(rowSize * page);
    };
    const dateOfBirth = selectedDate && selectedMonth && selectedYear
    ? `${selectedMonth}-${selectedDate}-${selectedYear}`
    : '';
    const selectedOption = watch('card');
    const onSubmit = (data) => {
        setCancelAgreementList(data)
        setSelectOption(selectedOption)
        setSelectedRows([]);
        const dob = selectedDate && selectedMonth && selectedYear
            ? `${selectedDate}-${selectedMonth}-${selectedYear.slice(-2)}`
            : '';
        // setShowTable(true);
        props.setShowForm(false);
        const dataObj = {
            "firstName": data.firstName.trim(),
            "lastName": data.lastName.trim(),
            "clientId": apid ? apid : null,
            "panNumber": data.ebt ? ("600875" + data.ebt ): null,
            "dob": dob,
            "size":size,
            "from": 0,
            "setObj": selectedOption,
           
        }
        
        setSubmittedData(dataObj);
        props.getCancelAgreementList(dataObj,size);
        setShowLoader(true);      

    };
    
    useEffect(()=>{
        if (showTable) {
            const dob = selectedDate && selectedMonth && selectedYear
                ? `${selectedDate}-${selectedMonth}-${selectedYear.slice(-2)}`
                : '';
            const payload = {
            "firstName": cancelAgreementlist.firstName,
            "lastName":cancelAgreementlist.lastName,
            "clientId": cancelAgreementlist.apid ? cancelAgreementlist.apid : null,
            "panNumber":  cancelAgreementlist.ebt ? ("600875" + cancelAgreementlist.ebt ) : null,
            "dob": dob,
            "size": size,
            "from": from
            } 
            props.getCancelAgreementList(payload);
            setShowLoader(true);        }
      },[props?.csaSignup?.refreshKey,size,from])

    // useEffect(() => {
    //     setAgreementList(props.csaSignup?.cancelAgreementList);
    // }, [props?.csaSignup?.refreshKey,size,from,tableSort])

      // useEffect(()=>{
    //     setShowTable(!props.showForm);       
    //     setMonth('');
    // },[props.showForm]);

useEffect(() => {
    const list = props?.csaSignup?.cancelAgreementList?.list;
    const error = props?.csaSignup?.cancelAgreementList?.error;

    if (!error && list.length > 0 && !props.showForm) {
        setShowTable(!props.showForm);
    } else {
        setShowTable(false);
    }
}, [props?.csaSignup?.cancelAgreementList]);
    useEffect(() => {
        const { list, total} = props?.csaSignup?.cancelAgreementList;
        let data = [];
        // setRows([]);
        setTimeout(() => {
            list.forEach(element => {
                element.agrmtId = element.id;
                element.id = element.setId;

                data.push(createData(element.agrmtId, element.id,  element.setId,element.vendorId, element.clientId, element.shareId, element.verbiageDocId,
                     element.vendorName, element.apprvlStatus, element.shareNam, 
                    element?.agrmntAppId, element.lastUpdtTs, element.shareCost, element?.shareInfo.dsc,
                    element.shareInfo?.shareQty,
                    element?.shareInfo?.pickupInfo?.address1 ? element?.shareInfo?.pickupInfo?.address1 : element?.shareInfo?.deliveryInfo?.address1,
                    element?.shareInfo?.pickupInfo?.address2 ? element?.shareInfo?.pickupInfo?.address2 : element?.shareInfo?.deliveryInfo?.address2,
                    element?.shareInfo?.pickupInfo?.city ? element?.shareInfo?.pickupInfo?.city : element?.shareInfo?.deliveryInfo?.city,
                    element?.shareInfo?.pickupInfo?.state ? element?.shareInfo?.pickupInfo?.state : element?.shareInfo?.deliveryInfo?.state,
                    element?.shareInfo?.pickupInfo?.zipcode ? element?.shareInfo?.pickupInfo?.zipcode : element?.shareInfo?.deliveryInfo?.zipcode,
                    element?.shareInfo?.pickupInfo?.day, element?.shareInfo?.pickupInfo?.openTime, element?.shareInfo?.pickupInfo?.closeTime,
                    element.cancelNotes, element.cancelESign,  element.clientNam,element.shareInfo?.endDate, element.paymentType, element.shareInfo?.shareQtyUnit, element.checkboxDisable,element.row,
                ));
            });
            setRows(data);
        }, 300);
        handleColumns();
        setAgreementList(total); 
        setShowLoader(false);      
    }, [props?.csaSignup?.cancelAgreementList]);

    const handleCancelUpdate = () => {
        
        const formData = getValues();
        const timeStamp = new Date().getTime();
        let role = "";
        if (userData?.Role === "ADMIN") {
            role = "ADM_";
        } else if(userData?.Role === "HIPCRD") {
            role = "CRD_";
        } else {
            role = "VDR_";
        }
        // let payload = [];
        // items.map(row => {
        //     payload.push({
        const payload = {
            "id": cancelRow?.agrmtId,
            "setId": cancelRow?.id,
            "shareId": cancelRow?.shareId,
            "vendorId": cancelRow?.vendorId,
            "clientId": cancelRow.clientId,
            "clientNam": cancelRow?.clientNam,
            "shareNam" : cancelRow?.shareNam,
            "vendorName": cancelRow?.vendorName,
            "apprvlStatus": "CANCLD",
            "paymentType" :cancelRow?.paymentType,
            "cancelNotes": selectedReason === '7' ? otherReason : cancelNotesText,
            "cancelESign": formData.cancelESign,
            "languageCode":languageCode,
            "lastUpdtUidNam": isLoggin ? role+userData?.id : "CSASGNUP",
            "createTimeStamp": timeStamp,
            "lastUpdtTimeStamp": timeStamp,
        }


            // });
        // });
        props.updateCancelAgreement([payload]);
        handleClose();
        // setSelectedRows([]);
        props.setOpen(false);
        props.setShowForm(true);
        props.setReset(!reset);
    }

    useEffect(()=>{
       if (props?.csaSignup?.shareCancel?.shareCancel && props?.csaSignup?.shareCancel?.shareCancel?.code == "200") {
         props.setOpen(false);
        }
    },[props?.csaSignup?.shareCancel?.shareCancel]);

    // eslint-disable-next-line no-unused-vars
    const handleCancelSubmit = () => {
        const bulkupdate = selectedRows.map(selectedRow => {
            selectedRow.apprvlStatus = (selectedRow.apprvlStatus == "DRAFT" || selectedRow.apprvlStatus == "APPRVD") ? "CANCLD" : "";            
            return {
                ...selectedRow, 
                agrmntAppId: selectedRow.agrmntAppId
            };
          });
        const payload = bulkupdate;
        if (payload.length > 0) {
            handleCancelUpdate(payload);
        }
        else {
            popUpAlert({
                title: "Error",
                text: "Select atleast one vendor",
                icon: "error",
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "OK",
                closeOnConfirm: true,
            });
        }
    }

    const handleDocument = (row) => {
        const noticesPayload = {
            "clientId": row?.clientId,
            "documentId": row?.verbiageDocId,

        }
        props.getCSADoc(noticesPayload)
    }

    useEffect(()=>{
        if (props.csaSignup?.csaDocument?.csaDocument?.stream) {
            var link = document.createElement("a");
            link.download = "csa_signup_agreement.pdf";
            link.href =`data:application/pdf;base64,${props.csaSignup?.csaDocument?.csaDocument?.stream}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },[props.csaSignup?.csaDocument?.csaDocument]);

    const pdfDownloader = (item) => {
        handleDocument(item);
    }

    const handleColumns = () => {
        const headers = [
            // { id: 'checkbox', label: '' },
            { id: 'details', label: language.details },
            {
                id: 'vendorName', label: language.vendorName,
                cell: (item) => {
                    let status = "";
                    if (item?.paymentType === "MNTHLY") {
                        status = language.monthly;
                        return (
                            <div>
                                <p>{item?.vendorName}</p>
                                <span style={{ color: '#006E52' }}>{item?.agrmntAppId}</span>
                                <button aria-label='Download your CSA share' style={{ border: 'none', color: '#006E52' }} onClick={() => pdfDownloader(item)}>
                                    <i className="fa fa-download" aria-hidden="true"></i>
                                </button><br />
                                {status && <span className="badge badge-primary">{status}</span>}
                            </div>
                        );
                    } else {
                        status = language.daily;
                        return (
                            <div>
                                <p>{item?.vendorName}</p>
                                <span style={{ color: '#006E52' }}>{item?.agrmntAppId}</span>
                                <button aria-label='Download your CSA share' style={{ border: 'none', color: '#006E52' }} onClick={() => pdfDownloader(item)}>
                                    <i className="fa fa-download" aria-hidden="true"></i>
                                </button><br />
                                {status && <span className="badge badge-grey">{status}</span>}
                            </div>
                        );
                    }
                }

            },
            {
                id: 'apprvlStatus',
                label: language.agreementStatus,
                cell: (item) => {
                    let status = "";
                    if (item.apprvlStatus == "DRAFT") {
                        status = "Pending";
                        return (<div style={{ color: "#FFBE6F", fontWeight: "bold" }}> {status} </div>)
                    }
                    else if (item.apprvlStatus == "REJCTD") {
                        status = "Rejected";
                        return (<div style={{ color: "#C43F0F", fontWeight: "bold" }}> {status} </div>)
                    }

                    else if (item.apprvlStatus == "APPRVD") {
                        status = "Approved";
                        return (<div style={{ color: "#529D8A", fontWeight: "bold" }}> {status} </div>)
                    }

                    else if (item.apprvlStatus == "CANCLD") {
                        status = "Cancelled";
                        return (<div style={{ color: "#C43F0F", fontWeight: "bold" }}> {status} </div>)
                    }
                }
            },
            {
                id: "shareNam",
                label: language.shareName,

            },
            {
                id: "endDate",
                label: language.expiresOn,
                cell: (item) =>{
                    return <div>{ moment(item.endDate).format('MM/DD/YYYY')}</div>
                    
                }

            },
            {
                id: 'shareCost',
                label: language.amount,
                cell: (item) => {
                    return <div>{"$ " + item.shareCost}</div>
                }

            },
            {
                id:'action',
                label: language.cancel,
                cell: (item) => {
                    if((item.apprvlStatus == "APPRVD") || (item.apprvlStatus == "DRAFT")) {
                        return (
                            <CustomButton tabIndex={0} variant='contained'  startIcon={<CancelIcon />} aria-label={'cancel your csa share'} onClick={()=> {handleClickOpen(item);}}>{language.cancel}</CustomButton>                
                        )
                    } else return (<><div style={{ paddingLeft: "40px" }}> - </div></>);
                }
            }

        ];
        setColumns(headers)
    }
   

    const handleSelectAll = (e) => {
        setSelectAll(e.target.checked);
        if (e.target.checked) {
            const filterRows = rows.filter(item => item.apprvlStatus !== "CANCLD");
            setSelectedRows(filterRows);
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowClick = (e, row) => {
        var updatedSelectedRows = [];
        if (e.target.checked) {
            updatedSelectedRows = [...selectedRows, row];
        } else {
            updatedSelectedRows = selectedRows.filter((r) => r.id !== row.id);
        }
        setSelectAll(true);
        setSelectedRows(updatedSelectedRows);
    };
    const handleSort = (item) => {
        let sortitem = {}
        if (item.sort == "" || item.sort == "DESC") {
            sortitem[item.id] = "ASC"
        } else {
            sortitem[item.id] = "DESC"
        }
        setTableSort(sortitem)
    };

    const renderDetails = (row) => {
        return (
            <CancelDetails
                row={row}
                language={language}
            />
        )
    }

    useEffect(() => {
        setSubmittedData(null);
      }, []);

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = (row) => {
        // if (selectedRows.length === 0) {
        //            setSelectMessage(
        //         <span className='dh-txt-danger'>
        //             <i className="fa fa-info-circle"></i>{" "}
        //             Please select atleast one vendor
        //         </span>
        //     );
        // } else {
            setOpen(true);
            reset();
        // }
        setCancelRow(row);

    };


    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick") 
        return;
        setOpen(false);
        // setSubmittedData(false);
        setSelectMessage('');
        // setShowTable(false);
        reset();
        setSelectedReason('');
    };
  

    useEffect(()=>{
        reset({
            "firstName": "",
            "lastName": "",
            "clientId": "",
            "panNumber": "",
            "date": "",
            "month": "",
            "year": "",
            "cancelNotes":"",
            "cancelESign":"",
            "ebt":"",
            "apid":"",

        });
        setMonth("");
        setApid('');
        setValue("year","");
        setSelectOption("");
        setValue("ebt","");
        setValue("apid","");
        // setValue("cancelESign","");
        // setValue("cancelNotes","");
    },[props.reset]);


    const handleChange = (e) => {
        let inputValue = e.target.value;
        inputValue = inputValue.replace(/^0+/, '');
    
        if (inputValue !== '') {
          const intValue = parseInt(inputValue, 10);
          if (!isNaN(intValue) && intValue >= 1 && intValue <= 31) {
            inputValue = intValue < 10 ? `0${intValue}` : `${intValue}`;
            setError('');
          } else {
            setError(language.validDayError);
            inputValue = '';
          }
        }
        setSelectedDate(inputValue);
      };
      
      
    const currentYear = new Date().getFullYear();
    const handleYearChange = (e) => {
        let value = e.target.value.trim();
        if (parseInt(value, 10) >= currentYear) {
          setYearError(language.validYearError)
          value='';
        } else {
          setYearError('');
          setSelectedYear(value);
        }
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            {/* <p style={{ fontSize: '23px', color: '#dc3545', fontFamily: 'Texta-bold' }}>{language.sorryToGo} </p> */}
            {!showTable ? (<>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <p className=" mb-0 gray-text">{language.pleaseProvide}</p>
                    <p>Fields marked with a asterisk <span className="ads-asterisk" aria-hidden="true">*</span> are required.</p>	
                    {/* <br /> */}
                    <Grid container spacing={2}>
                        {/* First Name */}
                        <Grid item xs={12} sm={6} md={4}>
                            <label className="dh-form-label font-bold" htmlFor='firstName'>{language.cancelFirstName} <span className="sr-only">required</span><span aria-hidden="true">*</span></label>                            
                            <TextField
                            name='firstName'
                            {...register('firstName', {
                                required: language.cancelFirstNameError,
                            })}
                            fullWidth
                            inputProps={{ maxLength:15}}
                            aria-label='first name'
                            autoComplete='off'
                            id='firstName'
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^A-Za-z\s'-]/g, '');
                                e.target.value = value;
                            }}
                            />
                            {errors['firstName'] && (
                            <span className="dh-txt-danger" role="alert" aria-live="assertive">
                                {errors['firstName'].message}
                            </span>
                            )}
                        </Grid>

                        {/* Last Name */}
                        <Grid item xs={12} sm={6} md={4}>
                            <label className="dh-form-label font-bold" htmlFor='lastName'>{language.cancelLastName} <span className="sr-only">required</span><span aria-hidden="true">*</span></label>                            
                            <TextField
                            name='lastName'
                            {...register('lastName', {
                                required: language.cancelLastNameError,
                            })}
                            fullWidth
                            inputProps={{ maxLength:20}}
                            aria-label='last Name'
                            autoComplete='off'
                            id='firstName'
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^A-Za-z\s'-]/g, '');
                                e.target.value = value;
                            }}
                            />
                            {errors['lastName'] && (
                            <span className="dh-txt-danger" role="alert" aria-live="assertive">
                                {errors['lastName'].message}
                            </span>
                            )}
                        </Grid>

                        {/* Date Of Birth */}
                        <Grid item xs={12} md={4}>
                            <label className="dh-form-label font-bold">{language.dateOfBirth}<span className="sr-only">required</span><span aria-hidden="true">*</span></label>
                            <div style={{ display: 'flex' }}>
                            <FormControl sx={{width: '44%', marginRight: '5px' }}>
                            <InputLabel id="demo-simple-select-label">Month</InputLabel>
                            <Select aria-label='month of birth'
                                {...register('month',{required: language.cancelMonthError})}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={month}
                                label={language.month}
                                onChange={handleMonthChange}
                            >
                                {monthOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
                            {/* <Select aria-label='month of birth' sx={{ width: '44%', marginRight: '5px' }} 
                                {...register('month',{required: language.cancelMonthError})}
                                value={month} 
                                onChange={handleMonthChange}
                                displayEmpty
                            >
                                <MenuItem value="" disabled>
                                    {language.month}
                                </MenuItem>
                                {monthOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select> */}
                            <TextField sx={{ width: '23%', marginRight: '5px' }}
                            autoComplete='off'
                                type="text"
                                aria-label='date of birth'
                                {...register('date', { required: language.cancelDateError })}
                                onKeyPress={(e) => {
                                    if (e.key && !/^\d$/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }} 
                                InputProps={{ inputProps: { min: 1, max: 31, maxLength: 2 } }}
                                // placeholder={language.day}
                                onChange={handleChange}
                                label={language.day}
                                />

                            <TextField sx={{ width: '30%' }}
                                autoComplete='off'
                                aria-label='year of birth'
                                 {...register('year', { required: language.cancelYearError })}
                                type="text"
                                onKeyPress={(e) => {
                                    if (e.key && !/^\d$/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }} 
                                // onChange={(e) => setSelectedYear(e.target.value)}
                                onChange={handleYearChange}
                                InputProps={{ inputProps: { min: 1, max: 31, maxLength:4} }}
                                // placeholder={language.year}
                                label={language.year}
                                />
                            </div>
                            {errors.month && (
                                <span className="dh-txt-danger" role="alert" aria-live="assertive">
                                    {errors.month.message}
                                </span>
                            )}&nbsp;
                            {errors.date && (
                                <span className="dh-txt-danger" role="alert" aria-live="assertive">
                                    {errors.date.message}
                                </span>
                            )} &nbsp;
                            {errors.year && (
                                <span className="dh-txt-danger"role="alert" aria-live="assertive">
                                    {errors.year.message}
                                </span>
                            )}&nbsp;
                            {error && <span className='dh-txt-danger'role="alert" aria-live="assertive">{error}</span>}
                            {yearError && <span className='dh-txt-danger' role='alert' aria-live='assertive'>{yearError}</span>}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: "5px" }}>
                        {/* EBT/APID */}
                        <Grid item xs={12} sm={6} md={4.2}>
                            <CardTypeInput
                                label={language.ebtCardAgencyId}
                                name="card"
                                register={register}
                                errors={errors}
                                value={selectedOption}
                                language={language}                         
                            />

                        </Grid>
                        {/* EBT Card Number */}

                        {selectedOption === 'ebt' && (
                            <Grid item xs={12} sm={6} md={3.8}>
                                <label className="dh-form-label font-bold" htmlFor="ebt">{language.ebtCard}  <span className="sr-only">required</span><span aria-hidden="true">*</span></label>
                                <FormControl fullWidth >
                                    <OutlinedInput
                                        id="outlined-adornment-amount"
                                        startAdornment={<InputAdornment position="start">600875</InputAdornment>}
                                        {...register('ebt', { required: language.cancelEbtCardError})}
                                        onKeyPress={(e) => {
                                            if (e.key && !/^\d$/.test(e.key)) {
                                              e.preventDefault();
                                            }
                                          }}                                        
                                        inputProps={{ maxLength: 12 }} 
                                    />
                                </FormControl>

                                {errors.ebt && (
                                    <span className="dh-txt-danger"role="alert" aria-live="assertive">
                                        {errors.ebt.message}
                                    </span>
                                )}
                            </Grid>)}

                        {/* Agency Id */}
                        {selectedOption === 'apid' && (
                            <Grid item xs={12} sm={6} md={3.8}>
                                 <label className="dh-form-label font-bold">{language.agencyId} <span className="sr-only">required</span><span aria-hidden="true">*</span></label>
                                <TextField sx={{ width: '100%' }}
                                    // label="DTA Agency ID"
                                    {...register('apid', { required: language.cancelAgencyIdError,
                                        })}
                                    name="apid"
                                    // value={apid}
                                    // register={register}
                                     errors={errors}

                                    // onKeyDown={isNumber}
                                    onKeyPress={(e) => {
                                        if (!/^\d$/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
                                          e.preventDefault();
                                        }
                                      }}
                                      inputProps={{ maxLength: 7 }} 
                                    onChange={(e) => setApid(e.target.value)}
                                    />
                                    {errors.apid && (
                                    <span className="dh-txt-danger"role="alert" aria-live="assertive">
                                        {errors.apid.message}
                                    </span>
                                )}
                            </Grid>)}
                            { props.showForm && (
                                <Grid item xs={12} sm={12} md={12}>
                                    <p className="mb-0 green-color">{language.anyQuestions}</p>
                                </Grid>
                            )}
                        <Grid item xs={12} sm={12} md={12}>
                            <Box display="flex" justifyContent="center">
                                <Button type="submit" 
                                sx={{ marginTop: "10px", backgroundColor: "#006E52", color: "fff", 
                                    "&:hover": { backgroundColor: '#006E52', color: '#ffffff' },
                                    // '&:focus-visible': {
                                    //     outline: '2px solid black',   
                                    //     outlineOffset: '2px',
                                    // }, 
                                "&:focus": {outline: "2px #F9F9F9 solid", outlineOffset: 0, boxShadow: "0 0 0 4px #193146"} 
                            }} 
                                variant="contained" color="primary">
                                    {language.submit}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Form> </>) : (<>
                    {submittedData && (
                        <Grid container spacing={2} style={{ fontFamily: 'text' }}>
                            <ThemeProvider theme={theme}>

                                <Grid item xs={6} md={4} sm={4}>
                                    <Typography variant="h6" gutterBottom component="div">{language.cancelFirstName}</Typography>
                                    {/* <Typography variant="subtitle1" gutterBottom> */}
                                       <span className='cancel-info'>{submittedData.firstName}</span> 
                                    {/* </Typography> */}
                                </Grid>
                                <Grid item xs={6} md={4} sm={4}>
                                    <Typography variant="h6" gutterBottom component="div">{language.cancelLastName}</Typography>
                                    {/* <Typography variant="subtitle1"  gutterBottom> */}
                                   <span className='cancel-info'>
                                        {submittedData.lastName}
                                    </span>
                                    {/* </Typography> */}
                                </Grid>
                                <Grid item xs={6} md={4} sm={4}>
                                    <Typography variant="h6" gutterBottom component="div">{language.dateOfBirth}</Typography>
                                    {/* <Typography variant="subtitle1" gutterBottom> */}
                                        {/* {submittedData.dob} */}
                                    <span className='cancel-info'>
                                        {dateOfBirth}
                                    </span>
                                    {/* </Typography> */}
                                </Grid>
                                {selectOption === 'apid' ? (
                                    <Grid item xs={6} md={12} sm={12}>
                                        <Typography variant="h6" gutterBottom component="div">{language.agencyId}</Typography>
                                        {/* <Typography variant="subtitle1" gutterBottom> */}
                                        <span className='cancel-info'>
                                            {submittedData.clientId}
                                        </span>
                                        {/* </Typography> */}
                                    </Grid>) : (
                                    <Grid item xs={6} md={12} sm={12}>
                                        <Typography variant="h6" gutterBottom component="div">{language.ebtCard}</Typography>
                                        {/* <Typography variant="subtitle1" gutterBottom> */}
                                        <span className='cancel-info'>
                                            {submittedData.panNumber}
                                        </span>
                                        {/* </Typography> */}
                                    </Grid>)}
                            </ThemeProvider>
                        </Grid>
                    )}

                    <Grid item xs={12} sx={{ marginTop: '40px' }}>
                        <TableComponent
                            columns={columns}
                            rows={rows}
                            expand={expand}
                            showDetails={true}
                            renderDetails={renderDetails}
                            total={agreementList}
                            handlePagination={handleNext}
                            selectAll={selectAll}
                            handleSelectAll={handleSelectAll}
                            handleRowClick={handleRowClick}
                            selectedRows={selectedRows}
                            handleSort={handleSort}
                            page={Math.floor(from / size)}
                            rowsPerPage={size}
                            dataLoading={showLoader}
                        />
                         <p style={{ fontSize: '23px', color: '#dc3545', fontFamily: 'Texta-bold' }}>{selectMessage}</p>
                    </Grid>
                    {/* {agreementList >= 1 && <> */}
                    <div>
                        {/* <Grid container sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <CustomButton variant='contained' aria-label={selectedRows.length === 0 ? 'please select atleast one vendor': 'cancel your csa share'} onClick={handleClickOpen}>Cancel</CustomButton>
                        </Grid> */}
                        <BootstrapDialog
                            onClose={handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={open}
                        
                        >
                            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                               {language.cancelCSAAgreement}
                                <Divider sx={{ borderWidth: 2, backgroundColor: "#006e52", width: '90px' }} />
                            </DialogTitle>
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <form onSubmit={handleSubmit(handleCancelUpdate)}>
                                <DialogContent dividers>

                                    <Row>
                                        <Col md={5} >
                                            <Form.Group as={Col} controlId="reason">
                                                <Form.Label aria-label={language["Reason for cancellation"]}>{language["Reason for cancellation"]}<span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col md={7}>
                                            <Form.Group as={Col} controlId='reasonDropdown'>
                                                <Form.Select size='lg' aria-label='Reason dropdown box'
                                                    {...register("cancelNotes", { required: language.pleaseChooseTheReason })}
                                                    value={selectedReason}
                                                    onChange={handleReasonChange}
                                                >
                                                    {cancelOptions.map(option => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.text}
                                                    </option>
                                                ))}

                                                </Form.Select>

                                                {errors.cancelNotes && (
                                                    <span className="dh-txt-danger"role="alert" aria-live="assertive">
                                                        {errors.cancelNotes.message}
                                                    </span>
                                                )}

                                            </Form.Group>
                                        </Col>
                                        {selectedReason === '7' && (
                                            <Col md={12}>
                                                <Form.Group controlId="otherReason">
                                                    <Form.Label>{language["Other Reason"]}</Form.Label>
                                                    <Form.Control
                                                        aria-label={language["Other Reason"]}
                                                        as="textarea"
                                                        rows={3}
                                                        maxLength={255}
                                                        value={otherReason}
                                                        placeholder='Max character: 255'
                                                        onChange={(e) => setOtherReason(e.target.value)}
                                                    />
                                                    {/* {errors.cancelNotes && (
                                                        <span className="dh-txt-danger">
                                                            {errors.cancelNotes.message}
                                                        </span>
                                                    )} */}
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group as={Col} controlId="signature">
                                                <Form.Label>{language.signature}<span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                                <Form.Control type="text" size="lg" maxLength={100}   {...register("cancelESign", { required: language.cancelSignatureErrMsg })} />
                                                {errors.cancelESign && (
                                                    <span className="dh-txt-danger" role="alert" aria-live="assertive">
                                                        {errors.cancelESign.message}
                                                    </span>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group as={Col} controlId="note">
                                                <Form.Label aria-label={language.noteForCancelCSA} >{language.noteForCancelCSA}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </DialogContent>
                                <DialogActions>

                                    <CustomButton variant='contained' type='submit' >{language.submit}</CustomButton>
                                </DialogActions>
                            </form>
                        </BootstrapDialog>
                    </div>
                    {/* </>} */}

                </>)}
            
        </Box >
    )
}
CancelFormComponent.propTypes = {
    getCancelAgreementList: PropTypes.func.isRequired,
    //getUpdate:PropTypes.object.isRequired,
    updateCancelAgreement: PropTypes.func.isRequired,
    getDocument: PropTypes.func.isRequired,
    getDocumentList: PropTypes.object,
    getCSADoc: PropTypes.func,
    csaSignup: PropTypes.object,
    showForm: PropTypes.bool,
    setShowForm: PropTypes.func,
    setOpen: PropTypes.func,
    refreshKey: PropTypes.func.isRequired,
    userAuth: PropTypes.object.isRequired,
    reset: PropTypes.bool,
    setReset: PropTypes.func,
    signupLanguage: PropTypes.object,
}
function mapDispatchToProps(dispatch) {
    return {
        getCancelAgreementList: (payload) => dispatch(actionType.getCancelAgreementList(payload)),
        refreshKey: () => dispatch(refreshKey()),
        updateCancelAgreement: (payload) => dispatch(actionType.updateCancelAgreement(payload)),
        getDocument: (payload) => dispatch(actionType.getDocument(payload)),
        getCSADoc: (payload) => dispatch(actionType.getCSADoc(payload)),

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CancelFormComponent);